// extracted by mini-css-extract-plugin
export default {"checkbox_text":"NewEmailFlowPopup_checkbox_text__l9dKe","checkbox_missing":"NewEmailFlowPopup_checkbox_missing__hv7kb","confirm_disabled":"NewEmailFlowPopup_confirm_disabled__8gIO9"};